import { use } from 'react'

import { assert } from '@eastcoal/common/utils/zustand'

import { AccountStatisticContext } from '../Context'

export const useAccountStatisticContext = () => {
  const store = use(AccountStatisticContext)

  return assert(store)
}
